module.exports = __webpack_public_path__ + "static/graph-290cd2a7c51cbc1d247ccc8e4d0bc795.jpg";